// extracted by mini-css-extract-plugin
export var btn = "Button-module--btn--2EgyS";
export var btnLink = "Button-module--btnLink--3BuEc";
export var btnIcon = "Button-module--btnIcon--OKM8C";
export var light = "Button-module--light--3Kmte";
export var dark = "Button-module--dark--15j6W";
export var lightIcon = "Button-module--lightIcon--1GI2u";
export var darkIcon = "Button-module--darkIcon--1Nm6y";
export var btnText = "Button-module--btnText--3a3Hp";